import React, { useEffect, useState } from 'react'
import { CAlert, CButton, CForm, CFormInput, CFormLabel, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import { useUI } from '../../shared/ui/UIProvider'
import { request } from '../../services'

function ScriptFormModal({ open, script, onClose, onSaved }) {
  const { toast } = useUI()
  const isEdit = Boolean(script && script.uuid)
  const [form, setForm] = useState({ name: '', url: '', description: '', keywords: '' })
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!open) return
    setError('')
    setForm({
      name: script?.name || '',
      url: script?.url || '',
      description: script?.description || '',
      keywords: script?.keywords || '',
    })
  }, [open, script])

  async function submit(event) {
    event.preventDefault()
    const name = form.name.trim()
    const url = form.url.trim()
    if (name === '') {
      setError('El nombre es obligatorio')
      return
    }
    if (!/^https?:\/\//i.test(url) && !/^www\./i.test(url)) {
      setError('La URL no parece valida (debe empezar con http(s):// o www.)')
      return
    }
    setSaving(true)
    const action = isEdit ? 'script_update' : 'script_create'
    const body = isEdit
      ? {
        ...script,
        name,
        url,
        description: form.description.trim(),
        keywords: form.keywords.trim(),
        status: String(script.status ?? 1),
      }
      : { name, url, description: form.description.trim(), status: '1' }
    const res = await request(action, { method: 'POST', body })
    setSaving(false)
    if (!res.ok) {
      const detail = res.data?.error || 'No se pudo guardar el script'
      setError(detail)
      toast(detail, 'danger')
      return
    }
    toast(isEdit ? `Script "${name}" actualizado` : `Script "${name}" creado`, 'success')
    onSaved()
  }

  return (
    <CModal visible={open} onClose={onClose} alignment="center">
      <CForm onSubmit={submit}>
        <CModalHeader><CModalTitle>{isEdit ? 'Editar script' : 'Nuevo script'}</CModalTitle></CModalHeader>
        <CModalBody>
          {error ? <CAlert color="danger">{error}</CAlert> : null}
          <div className="mb-3">
            <CFormLabel>Nombre</CFormLabel>
            <CFormInput value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} placeholder="Mi Script" />
          </div>
          <div className="mb-3">
            <CFormLabel>URL</CFormLabel>
            <CFormInput value={form.url} onChange={(event) => setForm({ ...form, url: event.target.value })} placeholder="https://bostonscriptsusuarios.basset.la/.../?token=" />
          </div>
          <div className="mb-3">
            <CFormLabel>Descripcion</CFormLabel>
            <CFormTextarea rows={2} value={form.description} onChange={(event) => setForm({ ...form, description: event.target.value })} />
          </div>
          {isEdit ? (
            <div className="mb-1">
              <CFormLabel>Keywords <span className="text-muted">(opcional)</span></CFormLabel>
              <CFormInput value={form.keywords} onChange={(event) => setForm({ ...form, keywords: event.target.value })} placeholder="hotel, pago, ..." />
            </div>
          ) : null}
        </CModalBody>
        <CModalFooter>
          <CButton color="light" onClick={onClose} disabled={saving}>Cancelar</CButton>
          <CButton color="success" className="btn-brand" type="submit" disabled={saving}>
            {saving ? <CSpinner size="sm" /> : (isEdit ? 'Guardar cambios' : 'Crear script')}
          </CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default ScriptFormModal
